import React from 'react';
const Cessione_quote = () => {
    return (
        <>            
            <table cellpadding="3" cellspacing="0">
                <tbody>
                    <tr>
                        <td colspan="3" valign="top">
                        <h2 id="3">&nbsp;Documenti&nbsp;necessari al Notaio per la cessione di quote persone fisiche</h2>
                        </td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">Carta d’identità o patente</td>
                        <td valign="top">&nbsp;</td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">Tesserino del codice fiscale</td>
                        <td valign="top">&nbsp;</td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">Copia autentica della procura</td>
                        <td valign="top">Per intervento di procuratore</td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">Autorizzazione giudiziale</td>
                        <td valign="top">Per rappresentanza di incapaci</td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">Permesso di soggiorno</td>
                        <td valign="top">Per extracomunitari</td>
                    </tr>
                    <tr>
                        <td valign="top">&nbsp;</td>
                        <td valign="top">&nbsp;</td>
                        <td valign="top">&nbsp;</td>
                    </tr>
                    <tr>
                        <td colspan="3" valign="top">
                        <h2 id="4">Documenti&nbsp;necessari al Notaio per la cessione di quote di enti e società</h2>
                        </td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">documento d’identità del legale rappresentante</td>
                        <td valign="top">&nbsp;</td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">certificato camerale</td>
                        <td valign="top">&nbsp;</td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">statuto vigente</td>
                        <td valign="top">&nbsp;</td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">libro verbali con delibera firmata</td>
                        <td valign="top">Per enti con consiglio di amministrazione</td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">copia autentica della procura</td>
                        <td valign="top">Per intervento di procuratore</td>
                    </tr>
                    <tr>
                        <td valign="top">&nbsp;</td>
                        <td valign="top">&nbsp;</td>
                        <td valign="top">&nbsp;</td>
                    </tr>
                    <tr>
                        <td colspan="3" valign="top">
                        <h2 id="5"><strong>Documenti inerenti il contratto di cessione</strong></h2>
                        </td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">Contratto preliminare</td>
                        <td valign="top">&nbsp;</td>
                    </tr>
                    <tr>
                        <td valign="top">&nbsp;</td>
                        <td valign="top">&nbsp;</td>
                        <td valign="top">&nbsp;</td>
                    </tr>
                    <tr>
                        <td colspan="3" valign="top">
                        <h2 id="6"><strong>Documenti inerenti la struttura della società oggetto di cessione</strong></h2>
                        </td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">Statuto vigente</td>
                        <td valign="top">&nbsp;</td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">Certificato camerale</td>
                        <td valign="top">&nbsp;</td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">Libro soci</td>
                        <td valign="top">Per società di capitali</td>
                    </tr>
                </tbody>
            </table>
        </>
        );
    }

export default Cessione_quote;